import { render, staticRenderFns } from "./CompletedLabel.vue?vue&type=template&id=04828718&scoped=true&"
import script from "./CompletedLabel.vue?vue&type=script&lang=js&"
export * from "./CompletedLabel.vue?vue&type=script&lang=js&"
import style0 from "./CompletedLabel.vue?vue&type=style&index=0&id=04828718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04828718",
  null
  
)

export default component.exports